/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import AnswerKeyQuestionsArray from './answerKeys/AnswerKeyQuestionsArray';
import AnswerKeyDialog from './answerKeys/AnswerKeyDialog';
import AnswerKeyAux from './answerKeys/AnswerKeyAux';
import AnswerKeyErrorIdentification from './answerKeys/AnswerKeyErrorIdentification';

// Create Document Component
export const AnswerKeyDoc = ({ data, dir }) => {
  const template_labels = [
    'TMP-L-007', // multiple choice - ad 1, kp 1, ru 1
    'TMP-L-008', // concept categorization - ad 5, kp 6, ru 4
    'TMP-L-009', // error identification - ad 6, kp none, ru 4
    'TMP-L-010', // summary evaluation - NONE
    'TMP-L-011', // linguistic evaluation - NONE
    'TMP-L-012', // register analysis - NONE
    'TMP-PE-011', // multiple choice - ad 1, kp 1, ru 1
    'TMP-PE-012', // concept categorization - NONE
    'TMP-PE-013', // supplemental - ad 1, kp 1, ru 1
    'TMP-PE-017', // dialog text - ad 1, kp 1, ru 1
    'TMP-PE-018', // dialog call - ad 1, kp 1, ru 1
    'TMP-PE-019', // dialog face to face - ad 1, kp 1, ru 1
    'TMP-A-002', // assessment reading
    'TMP-A-003' // assessment listening
  ];

  // get the page data for the templates we want to include
  // must go through each section in the lesson and find the pages with the correct template labels
  const filteredData = [];
  data.sections.forEach((section) => {
    section.pages.forEach((page) => {
      if (template_labels.includes(page.template.label)) {
        filteredData.push({
          ...page
        });
      }
    });
  });

  // This is a placeholder for pages that don't match any template
  const placeHolder = (pData, pIndex) => {
    return (
      <div
        key={pData.screen + '_' + pIndex}
        className="page"
        style={{
          width: '8.5in',
          minHeight: '11in',
          padding: '0.5in',
          boxSizing: 'border-box',
          margin: '0 auto',
          border: '1px #D3D3D3 solid',
          borderRadius: '4px',
          background: 'darkgray',
          pageBreakAfter: 'always'
        }}
      >
        <p>Page: {pData.label}</p>
        <p>Title: {pData.title}</p>
        <p>Template: {pData.template.label}</p>
        <p>Need custom code!</p>
      </div>
    );
  };

  const displayPage = (pData, pIndex) => {
    let pageData = pData;

    const notStandardShapeTemplates = [
      'TMP-L-009', // error identification - vastly different
      'TMP-L-010', // summary evaluation - not used
      'TMP-L-011', // linguistic evaluation - not used
      'TMP-L-012', // register analysis - not used
      'TMP-PE-013', // aux item - only type 4 of importance
      'TMP-PE-017', // dialog - no questions
      'TMP-PE-018', // dialog - no questions
      'TMP-PE-019', // dialog - no questions
      'TMP-A-002', // assessment reading - no core array, just single question
      'TMP-A-003' // assessment listening - no core array, just single question
    ];

    const hasNotStandardShape = notStandardShapeTemplates.includes(
      pData.template.label
    );

    if (hasNotStandardShape) {
      switch (pData.template.label) {
        case 'TMP-L-009': // error identification
          return (
            <AnswerKeyErrorIdentification
              key={pageData.screen + '_' + pIndex}
              lesson={data}
              data={pageData}
              dir={dir}
            />
          );
        case 'TMP-PE-013': // aux item
          return (
            <AnswerKeyAux
              key={pageData.screen + '_' + pIndex}
              lesson={data}
              data={pageData}
              dir={dir}
            />
          );
        case 'TMP-PE-017': // dialog
          return (
            <AnswerKeyDialog
              key={pageData.screen + '_' + pIndex}
              lesson={data}
              data={pageData}
              dir={dir}
            />
          );
        case 'TMP-PE-018': // dialog call
          return (
            <AnswerKeyDialog
              key={pageData.screen + '_' + pIndex}
              lesson={data}
              data={pageData}
              dir={dir}
            />
          );
        case 'TMP-PE-019': // dialog face to face
          return (
            <AnswerKeyDialog
              key={pageData.screen + '_' + pIndex}
              lesson={data}
              data={pageData}
              dir={dir}
            />
          );
        case 'TMP-A-002': // assessment reading
          // converting the single question to the array and able to go through standard question rendering code
          pageData = {
            ...pData,
            content: {
              ...pData.content,
              core: [pData.content.question]
            }
          };
          break;
        case 'TMP-A-003': // assessment listening
          // converting the single question to the array and able to go through standard question rendering code
          pageData = {
            ...pData,
            content: {
              ...pData.content,
              core: [pData.content.question]
            }
          };
          break;
        default:
          return placeHolder(pData, pIndex);
      }
    }

    return (
      <AnswerKeyQuestionsArray
        key={pageData.screen + '_' + pIndex}
        lesson={data}
        data={pageData}
        dir={dir}
      />
    );
  };

  return (
    <div className="bg-white w-full">
      {filteredData.map((item, index) => displayPage(item, index))}
    </div>
  );
};
